<template>
  <a-card :bordered='false'>
    <SmallSquare class="" content='全部文字消息保存30天，其他类型消息只保存3天，已收藏消息可永久保存。48小时内进行回复。' :padding='false'></SmallSquare>
    <a-tabs @change="callback">
      <a-tab-pane :key="0" tab="全部消息"></a-tab-pane>
      <a-tab-pane :key="1" tab="已收藏的消息"></a-tab-pane>
    </a-tabs>
    <div class="m-b-20" v-if='search.is_collection == ""'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeTime" />
    </div>
    <div class='m-b-20'>
      <a-checkbox v-if='search.is_collection == ""' v-model:checked="hideKey" @change="onChange">隐藏关键词消息</a-checkbox>
    </div>
    <a-spin :spinning='listLoading'>
      <div v-if='msgList.length > 0'>
        <div class="s_bor10 s_bf4f s_over_h p-t-10 p-b-10 p-l-20 p-r-20 m-b-20 " v-for='(item,index) in msgList'
          :key='index'>
          <div class="s_flex_bian_c">
            <div class="width90 s_flex_ali">
              <img class="width-65 height-65 m-r-20" :src="item.headimgurl" alt="">
              <div class="width85">
                <div class="s_flex_ali">
                  <p class=" fz-16 s_font_b m-r-20">{{item.nickname}}</p>
                  <p class="s_c999">{{item.create_time}}</p>
                </div>
                <p class="s_c333 m-t-10">{{item.msg}}</p>
              </div>
            </div>
            <div class="width20">
              <div class="s_flex_bian_c width60 s_mauto ">
                <StarOutlined v-if='item.is_collection == 0' style="font-size: 20px;" v-has:wxMsgCollect='()=>collection(index)' />
                <StarFilled v-else style="font-size: 20px;color: #05486A;" v-has:wxMsgCollect='()=>collection(index)' />
                <RotateRightOutlined v-has:wxMsgReply='()=>{item.msgType = !item.msgType;msg_id = item.id}' style="font-size: 20px;" />
              </div>
              <div class="m-t-35 clearfix" v-has:wxMsgLog='()=>lookMsg(item.openid)'>
                <a class="fr" href="javascript:;">查看聊天记录（{{item.reply_count}}）</a>
                <span style="color:#f04635" class="m-r-10 fr" v-if="item.is_reply_text">{{item.is_reply_text}}</span>
              </div>
            </div>
          </div>
          <div class="s_bt1 p-20 m-t-15" v-if='item.msgType'>
            <a-textarea class="m-b-20" v-model:value="sendOutText" placeholder="请输入要回复的内容" :rows="4" />
            <a-button class="width-100 m-r-20" type="primary" v-has:wxMsgReply='()=>sendOut(index)'>发送</a-button>
            <a-button class="width-100" type="primary" ghost @click='item.msgType = !item.msgType'>收起</a-button>
          </div>
        </div>
      </div>
      <a-empty class="m-t-30" v-else />
    </a-spin>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-card>
  <a-modal  :keyboard="false" title="聊天记录" :width='1300' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <div class="s_bor10 s_bf4f s_over_h p-t-10 p-b-10 p-l-20 p-r-20 m-b-20 s_flex_bian_c" v-for='item in lookMsgList'
      :key='item'>
      <div class="s_flex_ali width90">
        <img class="width-65 height-65 m-r-20" :src="item.headimgurl" alt="">
        <div class="width85">
          <div class="s_flex_ali">
            <p class=" fz-16 s_font_b m-r-20">{{item.nickname}}</p>
            <p class="s_c999">{{item.create_time}}</p>
          </div>
          <p class="s_c333 m-t-10">{{item.msg}}</p>
        </div>
      </div>
      <a href="javascript:;" v-if="item.is_reply_text">已回复</a>
    </div>
    <a-empty class="m-t-30" v-if='lookMsgList.length == 0' />
  </a-modal>
</template>
<script>
  import { StarOutlined, StarFilled, RotateRightOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getWx_msg,setWx_msgCollection,setWx_msgReply,getWx_msgChatRecord } from '@/api/public_wx';
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 10,
    is_keyword:'',
    is_collection:'',
    start_time:'',
    end_time:''
  };
  export default {
    components: { StarOutlined, StarFilled, RotateRightOutlined },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        time:[],
        listLoading: false,
        total: 1,
        msgList: [],
        lookMsgList:[],
        visible: false,
        sendOutText:'',
        msg_id:'',
        hideKey:false
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 
      const callback = (e) =>{
        state.msgList = []
        state.total = 0;
        search.value.page = 1;
        search.value.limit = 10;
        search.value.start_time = ''
        search.value.end_time = ''
        search.value.is_collection = e === 0 ? '':1
        initData(search.value);
      }
      // 时间筛选
      const onChangeTime = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value);
      }
      // 是否隐藏关键词
      const onChange = (e) =>{
        search.value.is_keyword = e.target.checked ? 1 : ''
        initData(search.value);
      }
      // 查看聊天记录
      const lookMsg = async(e) =>{
        let res = await getWx_msgChatRecord({openid:e}).then(res => res.data);
        if (iscode(res)) {
          state.lookMsgList = res.data.data;
          state.visible = true
        } else {
          message.error(res.msg);
        }
      }
      // 收藏
      const collection = async(index) =>{
        let res = await setWx_msgCollection({id:state.msgList[index].id,is_collection:state.msgList[index].is_collection ? 0 : 1}).then(res => res.data);
        if (iscode(res)) {
          initData(search.value)
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
      }
      // 发送消息
      const sendOut = async(index) =>{
        let res = await setWx_msgReply({msg_id:state.msg_id,msg:state.sendOutText}).then(res => res.data);
        if (iscode(res)) {
          state.msg_id = ''
          state.sendOutText = ''
          state.msgList[index].msgType =  false
          message.success(res.msg);
        initData(search.value)
        } else {
          message.error(res.msg);
        }
      }
      //获取消息列表
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getWx_msg(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            state.msgList = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        pageCurrentChange,
        pageSizeChange,
        callback,
        onChangeTime,
        lookMsg,
        collection,
        sendOut,
        onChange
      };
    },
  };
</script>